module.exports = __webpack_public_path__ + "img/studium.41a94817.png";